import { areWeekHoursEqual } from './areWeekHoursEqual.js';
/**
 * Finds the index of an address in the addresses array that matches both the full address and the hours.
 * @param {WidgetLocation[]} locations - Array of address objects.
 * @param {string} fullAddress - The full address string to match.
 * @param {ADDHours} hours - The hours object to match.
 * @returns {number} Index of the matching address, or -1 if not found.
 */
export const findExistingAddressHoursIndex = (
	locations,
	fullAddress,
	hours
) => {
	return locations.findIndex(
		(existingAddress) =>
			existingAddress.address === fullAddress &&
			areWeekHoursEqual(existingAddress.hours, hours)
	);
};
